import React from 'react';
import { useHistory } from 'react-router-dom';
import LuxuryBoxForm from 'forms/LuxuryBoxForm';
import EditVenueContext from 'contexts/EditVenueContext';
import LuxuryBox from 'types/models/LuxuryBox';
import { getLuxuryBox } from 'services/venuesServices';

export default (): JSX.Element => {
  const history = useHistory();
  const { selectedLuxuryBox, selectedVenue } = React.useContext(EditVenueContext);
  const [completeLuxuryBox, setCompleteLuxuryBox] = React.useState<LuxuryBox | null>(null);

  const load = React.useCallback(async (id: string) => {
    const luxuryBox = await getLuxuryBox(id);
    if (!luxuryBox) {
      history.push('/private/venues');
      return;
    }
    setCompleteLuxuryBox(luxuryBox);
  }, []);

  React.useEffect(() => {
    if (!selectedLuxuryBox || !selectedVenue) {
      history.push('/private/venues');
    } else {
      load(selectedLuxuryBox.id);
    }
  }, [selectedLuxuryBox, selectedVenue]);

  if (!completeLuxuryBox) return <></>;
  return <LuxuryBoxForm luxuryBox={completeLuxuryBox} />;
};
